// extracted by mini-css-extract-plugin
export default {"listContainer":"productsListComponent_listContainer__ai1TK","productCard":"productsListComponent_productCard__e6dVH"};